import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const NO_EMPS = { data: { employees: [], owner: null } };

export function useOrg(withEmployees = true) {
  const [data, setData] = useState(null);
  const load = useCallback(async () => {
    const [c, s, b, e] = await Promise.all([
      api.get("/org/catalog"), api.get("/org/setup"), api.get("/org/branches"),
      withEmployees ? api.get("/org/employees").catch(() => NO_EMPS) : Promise.resolve(NO_EMPS),
    ]);
    setData({
      catalog: c.data.departments, permissions: c.data.permissions, setup: s.data,
      branches: b.data.branches, employees: e.data.employees, owner: e.data.owner,
    });
  }, [withEmployees]);
  useEffect(() => { load(); }, [load]);
  return { data, reload: load };
}

// Departments enabled for the organisation, each with only its enabled roles.
export function enabledDepartments(data) {
  if (!data) return [];
  const sel = data.setup.departments;
  return data.catalog
    .filter((d) => !sel.length || sel.includes(d.key))
    .map((d) => {
      const rs = data.setup.roles[d.key];
      return { ...d, roles: rs && rs.length ? d.roles.filter((r) => rs.includes(r.name)) : d.roles };
    });
}

export const deptName = (data, key) => data?.catalog.find((d) => d.key === key)?.name || key || "—";
